import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQ = [
  { q: "C'est quoi le FIPU ?", a: "C'est un mécanisme de financement public issu de la loi retraite de 2023, géré par la CARSAT. Les aides sont versées sur dossier déposé auprès de votre caisse, après instruction et sous conditions d'éligibilité." },
  { q: "Mon entreprise est-elle éligible ?", a: "Si vous avez au moins un salarié, êtes à jour de vos cotisations URSSAF et inscrit à la médecine du travail, vous êtes très probablement éligible. Tous les secteurs d'activité sont concernés. Le test en 30 secondes vous donne la réponse immédiate." },
  { q: "Combien peut-on toucher ?", a: "Le cadre prévoit un cumul possible jusqu'à 75 000 € sur la durée du dispositif. Le montant exact dépend de votre situation. Nous vous le précisons lors du premier appel." },
  { q: "Quand est-ce qu'on vous paie ?", a: "Jamais avant que la subvention ne soit versée par la CARSAT sur votre compte. C'est contractuel à chaque étape : aide encaissée, puis facturation, puis étape suivante. Aucune avance, aucun engagement caché." },
  { q: "Combien de temps prend un dossier ?", a: "Le montage prend généralement deux à quatre semaines. Le délai de versement par la CARSAT dépend ensuite des cycles de traitement, mais la majorité des dossiers conformes sont versés dans les trois mois suivant le dépôt." },
  { q: "Est-ce que c'est légal ?", a: "Entièrement. Le FIPU est un dispositif officiel d'État, vérifiable sur ameli.fr. Notre rôle consiste à accompagner les entreprises dans le montage et le suivi des dossiers CARSAT — prestations encadrées par un contrat signé." },
];

export default function FAQ_Section() {
  return (
    <section id="faq" className="bg-[var(--pc-bg-soft)] border-y pc-line">
      <div className="mx-auto max-w-3xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="text-center">
          <span className="inline-block tricolor-stripe !h-2.5 mb-5" aria-hidden />
          <div className="text-[11.5px] tracking-[0.18em] uppercase pc-text-muted font-semibold mb-4">Questions fréquentes</div>
          <h2 className="display-2 pc-text-ink text-balance" data-testid="faq-h2">
            Tout, en clair.
            <span className="block pc-text-muted font-serif-emph mt-1">Sans petites lignes.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full mt-16" data-testid="faq-accordion">
          {FAQ.map((it, i) => (
            <AccordionItem
              key={it.q}
              value={`item-${i}`}
              className="border-b pc-line last:border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left hover:no-underline py-7">
                <span className="text-[18px] sm:text-[19.5px] pc-text-ink pr-6 leading-snug font-semibold tracking-[-0.015em]">{it.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pc-text-muted text-[15.5px] leading-[1.65] pb-7 pr-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQ.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}
